import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Icons as Icon } from '../../Icons/Icons';
import { Button, Wrapper } from 'components';

import { Table, Avatar } from 'components-antd';

import styles from './styles.module.scss';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Task } from 'pages/Workshop/Transactions/TransactionTasks/components';
import { getSymphonyTransactions } from 'api/symphony';
import { resetTransactionEffect } from 'store/effects';
import { useDispatch } from 'react-redux';

export const ListingsModal = ({ row, variant = 'preListing', timePeriod }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isPending, setIsPending] = useState(true);

  const fetchClientsData = async () => {
    const statusMapping = {
      preListing: 'PreListing',
      officeExclusive: 'OfficeExclusive',
      comingSoon: 'ComingSoon',
      activeListing: 'ActiveListing',
      onHold: 'On Hold',
      underContractListing: 'Under contract',
      preListingDual: 'PreListing',
      officeExclusiveDual: 'OfficeExclusive',
      comingSoonDual: 'ComingSoon',
      activeListingDual: 'ActiveListing',
      onHoldDual: 'On Hold',
      underContractDual: 'Under contract',
      clearToCloseDual: 'Clear to close',
      underContractPurchase: 'Under contract',
      clearToClose: 'Clear to close',
    };
    try {
      const status = statusMapping[variant];
      const { data } = await getSymphonyTransactions({
        agentId: row?.Id,
        status: status,
        isDual: variant.includes('Dual'),
        isListingSide:
          variant === 'underContractPurchase' || variant === 'clearToClose' ? false : true,
        timePeriod,
      });
      if (data?.length) {
        setData(data);
      }
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => {
    fetchClientsData();
  }, []);

  const detailColumns = [
    {
      title: 'Transaction',
      key: 'Property',
      dataIndex: 'Property',
      sorter: (a, b) => {
        let name = a?.Property?.Address?.Line1;
        let secondName = b?.Property?.Address?.Line1;
        return name.localeCompare(secondName);
      },
      render: ({ Address }) => {
        return (
          <div className={classNames(styles.val, styles.task)}>
            <Icon className={styles.icon} variant={Icon.ARROWS} />
            <div>
              <p className={styles.p1}>{`${Address?.Line1}${
                Address?.Line2 ? ` #${Address?.Line2}` : ''
              }`}</p>
              <p className={styles.p2}>
                {Address?.City + `, ` + Address?.State + ` ` + Address?.Zip}
              </p>
            </div>
          </div>
        );
      },
    },
    {
      title: 'Price',
      key: 'Price',
      dataIndex: 'Price',
      sorter: (a, b) => {
        const priceA = a?.Price ?? 0;
        const priceB = b?.Price ?? 0;
        return priceA - priceB;
      },
      render: (Price) => {
        return (
          <div className={styles.val}>
            {Price.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
            })}
          </div>
        );
      },
    },
    {
      title: 'Client',
      key: 'Clients',
      dataIndex: 'Clients',
      sorter: (a, b) => {
        let name = a?.Clients?.[0] || '';
        let secondName = b?.Clients?.[0] || '';
        return name.localeCompare(secondName);
      },
      render: (Clients) => (
        <div className={classNames(styles.val, styles.client)}>
          {Clients?.[0] && (
            <Avatar className={styles.avatar} size={24} src={''}>
              {Clients?.[0]
                .split(' ')
                .map((name) => name.charAt(0).toUpperCase())
                .join('')}
            </Avatar>
          )}
          <p className={styles.name}>{Clients?.[0] || '-'}</p>
        </div>
      ),
    },
    {
      title: 'Closing/Expires',
      key: 'Date',
      dataIndex: 'Date',
      sorter: (a, b) => {
        const dateA = new Date(a?.Date).getTime();
        const dateB = new Date(b?.Date).getTime();
        return dateA - dateB;
      },
      render: (Date) => {
        const isExpired = moment(Date).isBefore(moment().startOf('day'));
        return (
          <div className={classNames(styles.val, styles.expiring, { [styles.expired]: isExpired })}>
            {moment(Date).format('MM/DD/YYYY')}
          </div>
        );
      },
    },
    {
      title: '',
      key: 'TransactionId',
      dataIndex: 'TransactionId',
      render: (TransactionId) => {
        return (
          <div className={classNames(styles.val, styles.buttons)}>
            <Button
              isPending={false}
              className={styles.button}
              onClick={() => {
                dispatch(resetTransactionEffect());
                history.push(`/workshop/transactions/${TransactionId}/overview`);
              }}
              title={'View'}
              disabled={false}
            />
          </div>
        );
      },
    },
  ];

  return (
    <Wrapper isPending={isPending}>
      <Task />
      <Table
        loading={false}
        className={styles.detailsTable}
        bordered
        columns={detailColumns}
        dataSource={data}
        pagination={false}
        showSorterTooltip={false}
      />
    </Wrapper>
  );
};
